<script lang="ts" setup>
</script>

<template>
    <span class="cookie-alert">
        This website uses cookies to ensure you get the best experience on our website.<br />
        To learn more, please refer to the
        <a href="#">Cookie policy page</a>.
    </span>
</template>

<style lang="scss" scoped>
    .cookie-alert
    {
        font-size: 0.875em;

        & > a
        {
            font-weight: bold;
        }
    }
</style>
